export default {
	/** @todo Probably do this instead of creating same computed everywhere
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		report() {
			return this.$store.get('reports/currentReport');
		},
	},
	*/
	methods: {
		$notify(type, text, to) {
			this.$store.set('notification',	{ type, text, to });
		},
	},
};
